import {ModelRepository, RequestMethod} from 'b302-frontend-library';
import Country from '../models/Country';

class CountryRepository extends ModelRepository<Country> {

    public constructor(continent: number) {
        super(`/continents/${continent}/countries`);
    }

    public getAll() {
        return this.request<Country[]>('/countries/all', RequestMethod.GET).send();
    }

    public getForContinent(continent: number) {
        return this.request<Country[]>(`/continents/${continent}/countries`, RequestMethod.GET).send();
    }

    destroy(model: Country) {
        return super.destroy(model) as Promise<Country>;
    }
}

export default CountryRepository;
